<template>
  <section class="about-section">
    <div class="container">
      <div class="about-wrapper">
        <!-- تصویر کتاب‌ها -->

        <div class="about-image-wrapper">
          <div class="image-border"></div>

          <img
            class="about-image"
            src="/iranphonics.jpg"
            alt="تصویر کتاب‌های "
          />
        </div>

       <!-- بخش متن -->
<div class="about-content">
  <div class="content-inner">

    <h2 class="about-title">
      {{ currentLang.aboutIranPhoenix }}
    </h2>

    <p class="about-description">
      {{ currentLang.aboutDescription }}
    </p>
  </div>

  <!-- آمار -->
  <div class="statistics-box">
    <div class="stat-item">
      <div class="stat-number">500+</div>

      <div class="stat-title">
        {{ currentLang.variousGames }}
      </div>

      <div class="stat-text">
        {{ currentLang.learningPracticeEntertainment }}
      </div>
    </div>

    <div class="stat-divider"></div>

    <div class="stat-item">
      <div class="stat-number">600+</div>

      <div class="stat-title">
        {{ currentLang.educationalVideos }}
      </div>

      <div class="stat-text">
        {{ currentLang.learningWithVideos }}
      </div>
    </div>

    <div class="stat-divider"></div>

    <div class="stat-item">
      <div class="stat-number">800+</div>

      <div class="stat-title">
        {{ currentLang.audioFiles }}
      </div>

      <div class="stat-text">
        {{ currentLang.listeningSkills }}
      </div>
    </div>
  </div>
</div>

          
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";
import { lang } from "@/plugins/lang";

import enAuth from "@/locales/en/aboutIranPhonics";
import faAuth from "@/locales/fa/aboutIranPhonics";

const translations = {
  en: enAuth,
  fa: faAuth,
};
const currentLang = computed(() => translations[lang.value]);
</script>

<style scoped>
.about-section {
  width: 100%;
  padding: 80px 0 110px;
  overflow: hidden;
  font-family: inherit;
}

.about-wrapper {
  position: relative;
  min-height: 390px;
  display: flex;
  align-items: center;
}

.about-image-wrapper {
  position: absolute;
  z-index: 3;
  left: 0;
  top: 30px;
  width: 260px;
  height: 310px;
}

/* قاب پشت تصویر */
.image-border {
  position: absolute;
  inset: -14px -14px 0 -14px;
  border-radius: 50% 50% 22px 22px / 28% 28% 22px 22px;
}

/* تصویر با فرم گنبدی */
.about-image {
  position: relative;
  z-index: 2;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;

  /*
   * دو مقدار اول مربوط به قوس بالای گنبد هستند
   * دو مقدار آخر مربوط به گوشه‌های پایین تصویر
   */
  border-radius: 50% 50% 20px 20px / 32% 32% 20px 20px;

  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
}

/* پنل تیره */
.about-content {
  position: relative;
  width: calc(100% - 160px);
  min-height: 370px;
  margin-left: auto;
  padding: 27px 35px 0 185px;
  color: #18325b;
  border-radius: 20px;

  background: radial-gradient(
      circle at 75% 25%,
      rgba(255, 255, 255, 0.06),
      transparent 30%
    ),
    linear-gradient(135deg, #6cceff 0%, #ffffff 55%, #eaf8ff 100%);
}

.content-inner {
  max-width: 700px;
}

.section-label {
  display: block;
  margin-bottom: 2px;
  color: rgba(255, 255, 255, 0.18);
  font-size: 17px;
  letter-spacing: 3px;
  text-align: right;
}

.about-title {
  text-align: start;
  margin: 0 0 24px;
  color: #18325b;
  font-size: clamp(24px, 3vw, 30px);
  font-weight: 800;
}

.about-description {
  margin-bottom: 10px;
  color: #18325b;
  font-size: 13px;
  line-height: 2.1;
  text-align: justify;
}

.contact-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-top: 3px;
  padding: 8px 18px;
  color: #fff;
  font-size: 13px;
  border: 1px solid rgba(255, 255, 255, 0.75);
  border-radius: 10px;
  background: transparent;
  transition: all 0.3s ease;
}

.contact-button:hover {
  color: #222;
  background: #fff;
  transform: translateY(-2px);
}

.button-arrow {
  font-size: 18px;
  line-height: 1;
}

/* باکس آمار */
.statistics-box {
  position: absolute;
  z-index: 4;
  right: 0;
  display: flex;
  align-items: center;
  
  padding: 10px 25px;
  color: #555;
  border-radius: 20px 20px 0 20px;
  background: linear-gradient(135deg, #ff7eb3, #ffb347);
      
    height: auto; /* ارتفاع کاملاً متناسب با متن داخل */
    min-height: fit-content;

  box-shadow: 0 12px 22px rgba(0, 0, 0, 0.08);
}

.stat-item {
  flex: 1;
  padding: 8px 15px;
  text-align: center;
}

.stat-number {
  display: inline-block;
  min-width: 75px;
  padding: 8px 10px;
  color: #18325b;
  font-size: 24px;
  font-weight: 800;
  border-radius: 20px 40px 20px 20px;
  background: #f7eee7;
}

.stat-title {
  margin-top: 5px;
  font-size: 15px;
  font-weight: 700;
  color: #fff;
}

.stat-text {
  margin-top: 3px;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  /* white-space: nowrap; */
}

.stat-divider {
  width: 1px;
  height: 75px;
  background: #d1d1d1;
}

.stat-message {
  position: absolute;
  right: 30px;
  top: -42px;
  color: #555;
  font-size: 13px;
  font-weight: 700;
}

/* تبلت */
@media (max-width: 991.98px) {
  .about-section {
    padding: 55px 0 80px;
  }

  .about-wrapper {
    min-height: 440px;
  }

  .about-image-wrapper {
    left: 10px;
    top: 50px;
    width: 220px;
    height: 275px;
  }

  .about-content {
    width: calc(100% - 110px);
    padding-left: 145px;
  }
}

/* موبایل */
@media (max-width: 767.98px) {
  .about-section {
    padding: 35px 0 45px;
        overflow: visible; /* یا حذف overflow: hidden */
  }

  .about-wrapper {
    display: flex;
    flex-direction: column;
    min-height: auto;
    padding: 0 12px;
  }

  .about-image-wrapper {
    position: relative;
    left: auto;
    top: auto;
    width: min(230px, 72%);
    height: 270px;
    margin: 0 auto -35px;
  }

  .about-content {
    width: 100%;
    min-height: auto;
    padding: 55px 20px 25px;
    border-radius: 20px;
  }

  .content-inner {
    max-width: none;
  }

  .section-label {
    font-size: 13px;
    text-align: center;
    letter-spacing: 2px;
  }

  .about-title {
    margin-bottom: 18px;
    text-align: center;
    font-size: 24px;
  }

  .about-description {
    font-size: 12px;
    line-height: 2;
    text-align: justify;
  }

  .contact-button {
    display: flex;
    width: fit-content;
    margin: 15px auto 0;
  }

  .stat-divider {
    display: none;
  }

  .stat-title {
    font-size: 12px;
  }

  .stat-text {
    font-size: 10px;
    white-space: normal;
  }

  .stat-message {
    position: absolute;
    top: -29px;
    right: 0;
    width: 100%;
    font-size: 12px;
    text-align: center;
  }
}

/* موبایل‌های کوچک */
@media (max-width: 375px) {
  .about-content {
    padding-right: 15px;
    padding-left: 15px;
  }

  .section-label {
    font-size: 11px;
  }

  .about-description {
    font-size: 11px;
  }
}
</style>
